import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// Import styles utilities
import {
	flex,
	customResponsive,
	customMinResponsive,
	size
} from 'components/styles';

// Import components
import { Heading } from 'components/elements';

export const SectionHeaderStyled = styled.div`
	border-bottom: 1px solid ${({ theme }) => theme.line};
	margin-bottom: 1.8rem;
`;

export const Wrapper = styled.div`
	${flex()}
	justify-content: space-between;
	align-items: flex-end;
	margin-right: 4.5rem;
`;

export const Box = styled.div`
	padding: 0 1.5rem;
	${flex()}
	justify-content: initial;
`;

export const HeadingFirstStyled = styled(Heading.First)`
	font-size: 2.4rem;
	margin: 0 3rem 1.5rem 0;
`;

export const NavWrapper = styled.div`
	border-bottom: 1px solid
		${({ isInverse, theme }) => (isInverse ? theme.grayBorder : theme.line)};

	background-color: ${({ isInverse, theme }) =>
		isInverse ? theme.black : 'transparent'};

	${({ boxShadow, theme }) =>
		boxShadow &&
		css`
			box-shadow: 0 0.6rem 0.7rem 0 ${rgba(theme.grayLight, 0.18)};
		`};
`;

export const NavContent = styled.div`
	padding: 0;
	display: grid;
	grid-template-rows: 1fr;
	margin-bottom: 1rem;

	${customMinResponsive(
		size.small,
		css`
			grid-template-columns: ${({ columns }) => columns};
			margin-bottom: 0;
			padding: 0rem 2rem;
		`
	)}

	${customResponsive(
		1600,
		css`
			padding-bottom: 0.6rem;
		`
	)}
`;
